var exports = {
  "i": "xaee3c4fa--0257d0--wrapper",
};

module.exports = exports;
